import { classes } from '../constants';

export class Video {
  constructor(video) {
    this.video = video;
    this.button = this.video.querySelector('button');
    this.iFrame = document.getElementById(
      this.button.getAttribute('aria-controls')
    );

    this.button.addEventListener('click', this.clickEventListener.bind(this));
  }

  clickEventListener(event) {
    this.video.classList.add(classes.active);
    this.iFrame.src = this.iFrame.getAttribute('data-src');
  }
}

const videos = document.querySelectorAll('[data-js-video]');

// Currently uses this selector:
// var tablist = document.querySelectorAll('[role="tablist"]')[0];
if (videos) {
  for (var i = 0; i < videos.length; ++i) {
    new Video(videos[i]);
  }
}
